import * as ActionTypes from '../actions/actionTypes'

export default function cookieReducer(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_COOKIE:
      return { ...state, cookie: action.value };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cookieReducer.js